import { useEffect, useRef } from "react";
import { FiX } from "react-icons/fi";
import CommunityPricingSettings from "./CommunityPricingSettings";
import { useAuth } from "../context/AuthContext";
import { useCourse } from "../context/CourseContext";

export default function PremiumSetupPopup({ onClose, onComplete }) {
  const { userId } = useAuth();
  const { course } = useCourse();
  const owner = String(course.creatorId?._id || course.creatorId) === String(userId);
  const ref = useRef(null);
  useEffect(() => {
    const dialog = ref.current, focused = document.activeElement;
    dialog.showModal();
    return () => { dialog.close(); focused?.focus(); };
  }, []);
  return <dialog ref={ref} aria-label="Set up premium membership" onCancel={event => { event.preventDefault(); event.stopPropagation(); onClose(); }} className="m-auto max-h-[90dvh] w-[calc(100%-2rem)] max-w-xl overflow-auto rounded-lg border border-[var(--app-border)] bg-[var(--app-surface)] p-6 text-[var(--app-text)] shadow-xl backdrop:bg-black/60">
    <div className="mb-2 flex justify-end"><button type="button" onClick={onClose} title="Close premium setup" aria-label="Close premium setup" className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-gray-100"><FiX /></button></div>
    {owner ? <CommunityPricingSettings onSaved={() => { onComplete?.(); onClose(); }} /> : <p>Only the channel owner can set up premium membership.</p>}
  </dialog>;
}
